/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuFilterDeliveryOptions_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterDeliveryOptions_searchBrowse$ref: FragmentReference;
export type SbRespRefineMenuFilterDeliveryOptions_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuFilterDeliveryOptions_searchBrowse$ref,
  +$refType: SbRespRefineMenuFilterDeliveryOptions_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterDeliveryOptions_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterDeliveryOptions_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4e1dcbb1ee07e7f788aed540fae8f0ae';
module.exports = node;
